import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ResponsiveModule } from 'ngx-responsive'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './common/sidebar/sidebar.component';
import { HeaderComponent } from './common/header/header.component';
import { PreferencesComponent } from './preferences/preferences.component';
import { NewsComponent } from './news/news.component';
import { DetailComponent } from './detail/detail.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { FooterComponent } from './common/footer/footer.component';
import { FiltersComponent } from './filters/filters.component';
import { BoletinesComponent } from './boletines/boletines.component';




import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MzSidenavModule,
  MzButtonModule,
  MzInputModule,
  MzValidationModule,
  MzModalModule,
  MzNavbarModule,
  MzSpinnerModule,
  MzIconModule,
  MzIconMdiModule,
  MzToastModule,
  MzDatepickerModule,
  MzCheckboxModule ,
  MzRadioButtonModule ,
  MzSelectModule ,
  MzTabModule,
  MzBadgeModule,
  MzPaginationModule
  

} from 'ngx-materialize';


import { NgxInfiniteScrollerModule } from 'ngx-infinite-scroller';


/**  */
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthenticationService } from './_services/authentication.service';


/** Masonry Grid */
import { NgxMasonryModule } from 'ngx-masonry';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { NewsService } from './_services/news.service';
import { UserService } from './_services/user.service';
import { PageMasterComponent } from './common/page-master/page-master.component';



@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    HeaderComponent,
    PreferencesComponent,
    NewsComponent,
    DetailComponent,
    HomeComponent,
    LoginComponent,
    PageNotFoundComponent,
    PageMasterComponent,
    FooterComponent,
    FiltersComponent,
    BoletinesComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxMasonryModule,
    ResponsiveModule.forRoot(),
    /** Materialize Modules */
    MzSidenavModule,
    MzButtonModule,
    MzInputModule,
    MzValidationModule,
    MzModalModule,
    MzNavbarModule,
    MzSpinnerModule,
    MzIconModule,
    MzIconMdiModule,
    MzToastModule,
    MzDatepickerModule,
    MzCheckboxModule, 
    MzRadioButtonModule, 
    MzSelectModule ,
    MzTabModule,
    MzBadgeModule,
    MzPaginationModule,

    /** Infinite Scroller */
    NgxInfiniteScrollerModule
  ],
  providers: [
    AuthenticationService,
    NewsService,
    UserService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
